import { render, staticRenderFns } from "./UsersAdministration.vue?vue&type=template&id=13da7e6c&scoped=true&"
import script from "./UsersAdministration.vue?vue&type=script&lang=js&"
export * from "./UsersAdministration.vue?vue&type=script&lang=js&"
import style0 from "./UsersAdministration.vue?vue&type=style&index=0&id=13da7e6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da7e6c",
  null
  
)

export default component.exports